import { local } from './storage'
import appData from './appData'
import { isEnv } from './env'

/**
 * Grabs the API key from available sources
 *
 * @returns {string|null} The API key, if found.
 */
export const getApiKey = () => {
	// Return the internal API key if available
	if ('undefined' !== typeof window.app && window.app.key) {
		return window.app.key
	}

	// Return the internal API key if available
	if (appData.get('key')) {
		return appData.get('key')
	}

	// If we are in dev mode...
	if (isEnv('development')) {

		// Then let's check the existance of the hot-now cookie, and use that.
		if (-1 < document.cookie.indexOf('_omhnuser=')) {
			let key = document.cookie.split('_omhnuser=')
			key = key[1] ? key[1].split(';')[0] : ''
			if (key) {
				return key
			}
		}
	}

	// Attempt to return the stored key. Will return null if not available
	return local.getItem('apiKey')
}